// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"14":"78493de3","60":"c0d499b4","523":"9458e3c9","779":"ac478d7a"}[chunkId] + ".css";
};